document.addEventListener("DOMContentLoaded", () => {







  gsap.registerPlugin(ScrollTrigger);

  // image with text part 
  gsap.from(".IWT_Content_Gsap", {
    xPercent: -100,
   yPercent:40,

   
    ease: "power1.out",

    scrollTrigger: {
      trigger: ".IWT_GSap",

      start: "top 120%",
      end:"bottom 120%",
     
      scrub:0.01,

     
    toggleActions: "play reverse play reverse"
    }
  });










const All_P = document.querySelectorAll(".IWT_Content_Gsap_P_Wrapper p");


const Every_Child_P = Array.from(All_P).filter(p => p.innerText.trim().length > 0);

if (Every_Child_P.length > 0) {
  gsap.from(Every_Child_P, {
    x: -100,
    yPercent:10,
    opacity:0,
   stagger:0.09,

   
ease: "power1.out",
    scrollTrigger: {
      trigger: ".IWT_Content_Gsap_P_Wrapper",
      start: "top 100%",
   
  
  
  
        toggleActions: "play reverse play reverse"
    }
  });
}








gsap.from(".IWT_Image_GSAP", {
    xPercent: 100,
    yPercent:50,

 
    ease: "power1.out",
    scrollTrigger: {
      trigger: ".IWT_GSap",

       scrub:1,
      start: "top 110%",
      end:"bottom 80%",
  
      

            // end:"bottom center ",
    toggleActions: "play reverse play reverse"
    }
  });




// text animation area 
//  gsap.from(".TEXT_GSAP_ANIMATION_ONE",{
//     xPercent: -100,
//     yPercent:100,
  
//     duration: 1.25,
//     ease: "power3.out",
//     scrollTrigger: {
//       trigger: ".custom_html_Gsap_Animation",
//       start: "top 80%",
//     toggleActions: "play reverse play reverse"
//     }

//  })



 
//  gsap.from(".TEXT_GSAP_ANIMATION_TWO",{


//     xPercent: 100,
//    yPercent:100,
//     duration: 1.25,
//     ease: "power3.out",
//     scrollTrigger: {
//       trigger: ".custom_html_Gsap_Animation",
//       start: "top 80%",
//     toggleActions: "play reverse play reverse"
//     }

//  })





gsap.from(".TEXT_GSAP_ANIMATION_ONE", {
    xPercent: -150,
    yPercent: 50,
    duration: 1.5,
    ease: "power3.out",
    scrollTrigger: {
        trigger: ".custom_html_Gsap_Animation",
        start: "top 80%", 
        // end: "top 20%", // Scrub er jonno ekta end point thaka bhalo
        scrub: true,    // Scroll er sathe animation control hobe
        toggleActions: "play reverse play reverse"
    }
});

// Dwitiyo Animation (Right & Bottom theke asbe)
gsap.from(".TEXT_GSAP_ANIMATION_TWO", {
    xPercent: 150,
    yPercent: 50,
    duration: 1.5,
    ease: "power3.out",
    scrollTrigger: {
        trigger: ".custom_html_Gsap_Animation",
        start: "top 80%",
        // end: "top 20%", // Scroll depth define kore
        scrub: true,    // Scroll er sathe move korbe
        toggleActions: "play reverse play reverse"
    }
});




// costal dry gin  animation 


gsap.from(".Feature_PW_GSAP_IMAGE-16246018082c8f54a4",{


xPercent:-100,
opacity:0,
duration:1.25,
ease: "power1.out",
scrollTrigger: {
      trigger: ".Feature_PW_GSAP-16246018082c8f54a4",
      start: "top 120%",
      end:"bottom center",
      scrub:1,
    toggleActions: "play reverse play reverse"
    }


    

})




gsap.from(".Feature_PW_GSAP_TEXT-16246018082c8f54a4",{


yPercent:100,
opacity:0,
duration:1.25,
ease: "power1.out",
scrollTrigger: {
      trigger: ".Feature_PW_GSAP-16246018082c8f54a4",
      start: "top 120%",
       end:"bottom center",
        scrub:1,
    toggleActions: "play reverse play reverse"
    }



});






gsap.from(".Feature_PW_GSAP_TEXT_PARAGRAPH_16246018082c8f54a4",{


yPercent:80,
opacity:0,

ease: "power1.out",
scrollTrigger: {
      trigger: ".Feature_PW_GSAP-16246018082c8f54a4",
      start: "top 100%",
       end:"bottom center",
       scrub:4,
    
    toggleActions: "play reverse play reverse"
    }



});

// sunset bitter 


gsap.from(".Feature_PW_GSAP_IMAGE-1624843841795ef652",{


xPercent:100,
yPercent:10,
opacity:0,

ease: "power1.out",
scrollTrigger: {
      trigger: ".Feature_PW_GSAP-1624843841795ef652",
          start: "top 120%",
      end:"bottom center",
      scrub:1,
    toggleActions: "play reverse play reverse"
    }



})






// 1. Timeline setup
// const tl = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".Feature_PW_GSAP-1624843841795ef652",
//     start: "top 80%",
//       scrub:true,
//     toggleActions: "play reverse play reverse"
//   }
// });

// // 2. Serial wise animation (Main Text -> Button -> Paragraph)
// tl.from(".Feature_PW_GSAP_TEXT-1624843841795ef652", {
//   yPercent: 100,
//   opacity: 0,
//   duration: 2,
//   ease: "power1.out" // Fast start, very slow end
// })
// .from(".Feature_PW_GSAP_TEXT_BUTTON_1624843841795ef652", {
//   yPercent: 100,
//   opacity: 0,
//   duration: 1,
//   ease: "power4.out"
// }, "-=0.7") // Agear animation sesh hobar ektu agei shuru hobe smoothness er jonno
// .from(".Feature_PW_GSAP_TEXT_PARAGRAPH_1624843841795ef652", {
//   yPercent: 100,
//   opacity: 0,
//   duration: 1.2,
//   ease: "power4.out"
// }, "-=0.7");



// 1. Main Text Animation (Normal Scrub)
gsap.from(".Feature_PW_GSAP_TEXT-1624843841795ef652", {
  yPercent: 100,
  opacity: 0,

  ease: "power1.out",
  scrollTrigger: {
    trigger: ".Feature_PW_GSAP-1624843841795ef652",
     start: "top 120%",
      end:"bottom center",
      scrub:1,

  }
});

// 2. Button Animation (Scrub: 3 - ektu slow follow korbe)
gsap.from(".Feature_PW_GSAP_TEXT_BUTTON_1624843841795ef652", {
  yPercent: 120,
  opacity: 0,
  
  ease: "power4.out",
  scrollTrigger: {
    trigger: ".Feature_PW_GSAP-1624843841795ef652",
      start: "top 80%",
      end:"bottom center",
      scrub:3
   

  }
});

// 3. Paragraph Animation (Scrub: 4 - aro beshi slow follow korbe)
gsap.from(".Feature_PW_GSAP_TEXT_PARAGRAPH_1624843841795ef652", {
  yPercent: 140,
  opacity: 0,

  ease: "power4.out",
  scrollTrigger: {
    trigger: ".Feature_PW_GSAP-1624843841795ef652",
       start: "top 80%",
      end:"bottom center",
     scrub:5
  }
});






// bottol animation 




gsap.from(".Bottol_Animation_Gsap_Content_One h2 ", { 
  xPercent: -120,
  opacity: 0,

  ease: "power1.out",

  scrollTrigger: {
    trigger: ".Bottol_Animation_Gsap_Content_One",
    start: "top 75%",
    end:"top 55%",
    scrub:0.5,
    toggleActions: "play reverse play reverse"
  }
});





gsap.from(".sf-panel--left img", { 
  xPercent: 20,
 opacity:0,
 duration:0.5,

  ease: "power1.out",

  scrollTrigger: {
    trigger: ".Bottol_Animation_Gsap",
    start: "top 180%",
    end:"bottom bottom ",
    scrub:true,
    toggleActions: "play reverse play reverse"
  }
});













gsap.from(".Bottol_Animation_Gsap_Content_One p", { 
  xPercent: -120,


  ease: "power1.out",

  scrollTrigger: {
    trigger: ".Bottol_Animation_Gsap_Content_One",
   start: "top 75%",
    end:"top 55%",
        scrub:0.7,
    toggleActions: "play reverse play reverse"
  }
});


gsap.from(".Bottol_Animation_Gsap_Content_One a", { 
  yPercent: -120,


  ease: "power1.out",

  scrollTrigger: {
    trigger: ".Bottol_Animation_Gsap_Content_One",
    start: "top 110%",
    end:"top 70%",
    scrub:0.7,
    toggleActions: "play reverse play reverse"
  }
});




gsap.from(".Bottol_Animation_Gsap_Content_Two h2",{


xPercent:120,
opacity:0,

ease: "power1.out",
scrollTrigger: {
      trigger: ".Bottol_Animation_Gsap_Content_Two",
 start: "top 100%",
    end:"top 60%",
          scrub:0.5,
    toggleActions: "play reverse play reverse"
    }



});


gsap.from(".Bottol_Animation_Gsap_Content_Two p",{


xPercent:110,
opacity:0,

ease: "power1.out",
scrollTrigger: {
      trigger: ".Bottol_Animation_Gsap_Content_Two",
        start: "top 100%",
         end:"top 60%",
          scrub:0.7,
    toggleActions: "play reverse play reverse"
    }



});


gsap.from(".Bottol_Animation_Gsap_Content_Two a ",{


xPercent:120,
opacity:0,

ease: "power1.out",
scrollTrigger: {
   trigger: ".Bottol_Animation_Gsap_Content_Two",
    start: "top 100%",
    end:"top 60%",
    scrub:0.7,
    toggleActions: "play reverse play reverse"
    }



});




gsap.from(".Bottol_One",{


yPercent:-50,
opacity:0,

ease: "power1.out",
scrollTrigger: {
      trigger: ".Bottol_Animation_Gsap",
      start: "top 50%  ",
        end: "bottom  bottom",
        scrub:0.5,
    toggleActions: "play reverse play reverse"
    }



});


gsap.from(".Bottol_Two",{


yPercent:110,
opacity:0,
ease: "power1.out",
scrollTrigger: {
      trigger: ".Bottol_Animation_Gsap",
       start: "top 50%",
        end: "bottom bottom ",
          scrub:0.5,
       toggleActions: "play reverse play reverse"
    }



});


gsap.from(".Bottol_Three",{


yPercent:135,
opacity:0,

ease: "power1.out",
scrollTrigger: {
      trigger: ".Bottol_Animation_Gsap",
    start: "top 50%  ",
        end: "bottom bottom ",
          scrub:0.7,
    toggleActions: "play reverse play reverse"
    }



});











// Gelary Animation 

// gsap.from(".Gelary_GSAP_ANIMATION_GELARY",
  
//   {

// xPercent:-15,
// yPercent:30,
// duration:1.5,


// ease: "power1.out",
// scrollTrigger: {
//       trigger: ".Gelary_GSAP_ANIMATION",
//       start: "top 80%",
  
   
//     toggleActions: "play reverse play reverse"
//     }



// });





// gsap.to(".Gelary_GSAP_ANIMATION_GELARY",
  
//   {
// delay:0.9,
// xPercent:5,

// duration:1.5,


// ease: "power1.out",
// scrollTrigger: {
//       trigger: ".Gelary_GSAP_ANIMATION",
//       start: "top 80%",
  
   
//     toggleActions: "play reverse play reverse"
//     }



// });





let mm = gsap.matchMedia();

// Shudhu 768px er upore kaj korbe
mm.add("(min-width: 768px)", () => {
  




  
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".Gelary_GSAP_ANIMATION",
      start: "top 30%",
      toggleActions: "play reverse play reverse"
    }
  });


  tl.from(".Gelary_GSAP_ANIMATION_GELARY", {
    xPercent: -5,
    yPercent: 20,
    duration: 1.5,
    ease: "power1.out"
  })
  

  .to(".Gelary_GSAP_ANIMATION_GELARY", {
    xPercent: 5,
    duration: 1.5,
    ease: "power1.out"
  }, "+=0.9"); // Sequence delay

  return () => { 

  };
});

let mn = gsap.matchMedia();

mn.add("(max-width: 767px)", () => {
  // Mobile Timeline
  const tlMobile = gsap.timeline({
    scrollTrigger: {
      trigger: ".Gelary_GSAP_ANIMATION",
      start: "top 90%", // Mobile-e ektu agei shuru kora bhalo
      end: "bottom 10%",
      scrub: 1,        // Scroll-er sathe smooth scrub hobe
    }
  });

  // Image gulo ke halka scale up kore rakha jate scroll-er sathe normal hoy
  tlMobile.from(".sf-media__img", {
    scale: 1.2,        // Image gulo 20% zoom thakbe
    y: 30,             // 30px niche thakbe
    duration: 1,
    stagger: 0.05,     // Ektar por ekta halka gap-e shuru hobe
    ease: "none"
  });

  return () => { 
    // Screen resize hole mobile settings clear hoye jabe
  };
});




gsap.from(".Gelary_GSAP_ANIMATION_GELARY_HEADING",
  
  {
xPercent:20,

opacity:0,
duration:2,
ease: "power1.out",
scrollTrigger: {
      trigger: ".Gelary_GSAP_ANIMATION",
      start: "top 80%",
    
    toggleActions: "play reverse play reverse"
    }



});









// slider animation 






// Heading element-ti select korun
// const heading = document.querySelector(".slider_GSAP_ANIMATION_HEADING p");

// if (heading) {
//     // 1. Text-ke <br> onujayi duto vage vag korun
//     const parts = heading.innerHTML.split(/<br\s*\/?>/i); 

//     // 2. Duto part-ke span tag-er bhetore dhukiye abar heading-e boshun
//     // Ekhane 'line-child' class dilam jate apni GSAP diye animate korte paren
//     heading.innerHTML = `
//         <span class="slider_GSAP_ANIMATION_HEADING_FIRST" style="display: block; overflow: hidden;">
//             <span class="line-child" style="display: block;">${parts[0]}</span>
//         </span>
//         <span class="slider_GSAP_ANIMATION_HEADING_SECOND" style="display: block; overflow: hidden;">
//             <span class="line-child" style="display: block;">${parts[1]}</span>
//         </span>
//     `;
// }







gsap.from(".slider_GSAP_ANIMATION_DIV", {
  yPercent: 150,
  // ease: "power1.out",
  scrollTrigger: {
    trigger: ".custom-slider_GSAP_ANIMATION_DIV",
    start: "top 60%",     // when top hits 85% viewport (near bottom)
    scrub: true,    // Scroll er sathe animation control hobe
    toggleActions: "play reverse play reverse"
  }
});

// gsap.from(".slider_GSAP_ANIMATION_DIV", {
    
//     yPercent: 100,
//     duration: 1.5,
//     ease: "power3.out",
//     scrollTrigger: {
//         trigger: ".custom-slider_GSAP_ANIMATION_DIV",
//         start: "top 50%", 
//         // end: "top 30%", // Scrub er jonno ekta end point thaka bhalo
//         scrub: true,    // Scroll er sathe animation control hobe
//         toggleActions: "play reverse play reverse"
//     }
// });

// gsap.registerPlugin(ScrollTrigger);

// gsap.fromTo(
//   ".slider_GSAP_ANIMATION_DIV",   // the element that moves
//   { yPercent: 100 },
//   {
//     yPercent: 0,
//     ease: "none",                 // best for scrub
//     scrollTrigger: {
//       trigger: ".custom-slider_GSAP_ANIMATION_DIV", // ✅ your real trigger
//       start: "top 50%",            // when trigger top crosses 50% viewport
//       end: "bottom bottom",        // stop when trigger fully fills viewport area
//       scrub: true,
//       invalidateOnRefresh: true,
//       // markers: true,
//     }
//   }
// );

// // important if images/slider change heights after load
// window.addEventListener("load", () => ScrollTrigger.refresh());



// gsap.from(".slider_GSAP_ANIMATION_DIV", {
//     xPercent: -150,
//     yPercent: 50,
//     duration: 1.5,
//     ease: "power3.out",
//     scrollTrigger: {
//         trigger: ".slider_GSAP_ANIMATION_DIV",
//         start: "top 80%", 
//         // end: "top 20%", // Scrub er jonno ekta end point thaka bhalo
//         scrub: true,    // Scroll er sathe animation control hobe
//         toggleActions: "play reverse play reverse"
//     }
// });








// cta section animation 


ScrollTrigger.matchMedia({

  /* =========================
     DESKTOP (FULL DIV VISIBLE)
     ========================= */
  "(min-width: 769px)": function () {

    // 🔹 Container (scale + fade)
// gsap.to(".CTA_GSAP_ANIMATION_Container", {
//   scale: 1,
//   opacity: 1,
//   ease: "none",
//   scrollTrigger: {
//     trigger: ".CTA_GSAP_ANIMATION",
//     start: "top 80%",     // start earlier (when section enters)
//     end: "bottom bottom",    // end later (when section is almost out)
//     scrub: true,           // adds smooth lag so it feels slower
//     // toggleActions: "play reverse play reverse"
//   }
// });

// gsap.fromTo(
//   ".CTA_GSAP_ANIMATION_Container",
//   { scale: 0.6, opacity: 1},
//   {
//     scale: 1,
//     opacity: 1,
//     ease: "none",
//     scrollTrigger: {
//       trigger: ".CTA_GSAP_ANIMATION",
//       start: "top 70%",     // ✅ NOT active at page load
//       end: "bottom bottom",       // ✅ longer/slower feel (tweak)
//       scrub: 0.8,
//       invalidateOnRefresh: true
//     }
//   }
// );

gsap.fromTo(
  ".CTA_GSAP_ANIMATION_Container",
  { scale: 0.6, opacity: 1 },
  {
    scale: 1,
    opacity: 1,
    ease: "none",
    immediateRender: false,
  
    scrollTrigger: {
      trigger: ".CTA_GSAP_ANIMATION",
      start: "top 70%",
      end: "bottom bottom",
      scrub: 0.8,
      invalidateOnRefresh: true,

      onEnter: () => window.dispatchEvent(new Event("resize")),
      onEnterBack: () => window.dispatchEvent(new Event("resize")),
    }
  }
);






// left 
    gsap.fromTo(
      ".CTA_GSAP_ANIMATION_LEFT",
      {
        flexBasis: "30%",

      },

      { delay:3,
      
        flexBasis: "20%",
        opacity: 1.5,
        duration: 2.2,
        ease: "none",
        scrollTrigger: {
          trigger: ".CTA_GSAP_ANIMATION",
          start: "center center",
          // end: "bottom bottom",
  
     scrub:0.5,
        }
      }
    );


      gsap.fromTo(
      ".CTA_GSAP_ANIMATION_RIGHT",
      {
        flexBasis: "100%",

      },
      { delay:3,
        flexBasis: "80%",
        opacity: 1,
        duration: 2.2,
        ease: "none ",
        scrollTrigger: {
          trigger: ".CTA_GSAP_ANIMATION",
          start: "top bottom",
          end: "bottom bottom",

          scrub:0.5,
        }
      }
    );

// gsap.fromTo(
//   ".CTA_GSAP_ANIMATION_RIGHT",
//   { flexBasis: "100%", opacity: 1 },
//   {
//     flexBasis: "90%",          // try: 90% / 92% / 95%
//     opacity: 1,
//     ease: "none",
//     immediateRender: false,    // helps prevent “stuck half state” on load
//     scrollTrigger: {
//       trigger: ".CTA_GSAP_ANIMATION",
//       start: "top 70%",
//       end: "bottom bottom",       // gives more scroll distance so it feels less jumpy
//       scrub: 0.5,
//       invalidateOnRefresh: true
//     }
//   }
// );







// const ctaTl = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".CTA_GSAP_ANIMATION",
//     start: "bottom bottom", 
//   }
// });

// // 1. Prothome Container er kaj hobe
// ctaTl.to(".CTA_GSAP_ANIMATION_Container", {
//   scale: 1,
//   delay: 2, // Apnar dewa delay
//   opacity: 1,
//   duration: 2,
//   ease: "none"
// })

// // 2. Container shesh holei LEFT shuru hobe (">" mane holo ager ta shesh hobar por)
// .fromTo(".CTA_GSAP_ANIMATION_LEFT", 
//   { flexBasis: "50%" }, 
//   { 
//     flexBasis: "20%", 
//     opacity: 1, 
//     duration: 2, 
//     ease: "none" 
//   }, 
//   ">" 
// )

// // 3. RIGHT animation-ti LEFT er sathe SAME TIME-e shuru hobe ("<" use korar karone)
// .fromTo(".CTA_GSAP_ANIMATION_RIGHT", 
//   { flexBasis: "100%" }, 
//   { 
//     flexBasis: "80%", 
//     opacity: 1, 
//     duration: 2, 
//     ease: "none" 
//   }, 
//   "<" // Eta ensure kore je LEFT ebong RIGHT ekshathe (At a time) kaj korbe
// );



  },

  /* =========================
     MOBILE
     ========================= */
  "(max-width: 768px)": function () {

    // 🔹 Container
    gsap.fromTo(
      ".CTA_GSAP_ANIMATION_Container",
      {
        scale: 0.8,

      },
      {
        scale: 1,
        opacity: 1,
        duration: 2.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".CTA_GSAP_ANIMATION",
          start: "top 60%",
          once: true
        }
      }
    );

    // 🔹 LEFT + RIGHT (stacked)
    // gsap.fromTo(
    //   ".CTA_GSAP_ANIMATION_LEFT, .CTA_GSAP_ANIMATION_RIGHT",
    //   {
    //     flexBasis: "100%",
    //     opacity: 0
    //   },
    //   {
    //     flexBasis: "100%",
    //     opacity: 1,
    //     duration: 2,
    //     ease: "power2.out",
    //     scrollTrigger: {
    //       trigger: ".CTA_GSAP_ANIMATION",
    //       start: "top 70%",
    //       once: true
    //     }
    //   }
    // );

  }

});








// const tl = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".CTA_GSAP_ANIMATION",
//     start: "top 80%",
//     toggleActions: "play none none none"
//   }
// });

// tl.fromTo(".CTA_GSAP_ANIMATION_LEFT",
//   { flexBasis: "60%", opacity: 0 },
//   { flexBasis: "100%", opacity: 1, duration: 3.3, ease: "power2.out" }
// )
// .fromTo(".CTA_GSAP_ANIMATION_RIGHT",
//   { flexBasis: "40%", opacity: 0 },
//   { flexBasis: "100%", opacity: 1, duration: 3.3, ease: "power2.out" },
//   "<"
// );





});




// document.addEventListener("shopify:section:load", () => {
//   ScrollTrigger.refresh();
// });
